import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LoadingButton from '@mui/lab/LoadingButton';

const DeleteCategoryModal = ({ categoryName, open, onClose, onConfirm }) => {
    
    const { t } = useTranslation();

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

  return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t('delete_category')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                {t('delete_category_confirmation', { categoryName })}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('cancel')}</Button>
                <LoadingButton
                    onClick={handleConfirm}
                    variant="contained"
                    color='error'
                    >
                    {t('delete')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
  );
};

export default DeleteCategoryModal;
